const addMetadata = (
  exercise,
  movement,
  newPrimary,
  primaryExercises = {},
  exerciseLibrary
) => {
  const found = [
    "squat",
    "deadlift",
    "bench",
    "clean",
    "jerk",
    "snatch",
    "overheadPress",
  ].includes(movement)
    ? primaryExercises[movement]
    : exerciseLibrary[newPrimary]?.find((ex) => ex.movement === movement);

  if (found) {
    exercise.exerciseTypeField = found.exerciseTypeField || "null";
    exercise.instructions = found.instructions || "null";
    exercise.video = found.video || "null";
    exercise.secondaryMuscleGroup = found.secondaryMuscleGroup || "null";
    exercise.primaryMuscleGroup = found.primaryMuscleGroup || "null";
  }
  return exercise;
};

export default addMetadata;
